export default __webpack_public_path__ + "static/media/Bg-4.0ee00ccf.png";